import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from "@ngx-translate/core";

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgVoxloudModule } from 'ng-voxloud';
import { LaddaModule } from 'angular2-ladda';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import {
  CompanySearchComponent,
  UserPasswordFormComponent,
  ConfirmationPopupComponent,
  TablePaginationComponent,
  EquipmentStatusComponent,
  DidStatusComponent,
  NumberTypeComponent,
  NumberTemporaryStatusComponent,
  QuantitySelectorComponent,
  DatePickerComponent,
  VerficationDataFormComponent,
  VerificationDataLabelComponent,
  CopyFeedbackPopupComponent,
  ConfirmationAlphanamePopupComponent,
  VerificationDataSelectionFormComponent,
  SubscriptionChangeCheckboxesComponent,
  PaymentInfoComponent,
  LineItemComponent,
  FooterCardComponent,
  DiscountItemComponent,
  CouponFormComponent,
  ConnectionTypeComponent,
  ResellerPaymentStatusComponent,
  ConnectivityEntryTypeComponent,
  SelectProviderComponent,
  IntegrationsTableComponent,
  IntegrationStatusComponent,
  IntegrationSelectUserComponent,
  IntegrationSelectTeamComponent,
  IntegrationUserMappingComponent,
  StatusIconComponent,
  SmsBundleBalanceComponent,
  SmsFraudLimitsComponent,
  FraudRateLimitsPopupComponent,
  LinksPopupComponent
} from './components';
import { DidTypePipe, DidClassPipe, PrettyPrintPipe, CountryCurrencyPipe, NoUnderscorePipe } from './pipes';
import { environment } from 'src/environments/environment';
import { DidStatusPipe } from './pipes/did-status.pipe';
import { VerifyPhoneNumberService } from './services//verify-phone-number/verify-phone-number.service';
import { UtilsService } from './services/utils/utils.service';
import { AddressService } from './services//address/address.service';



const COMPONENTS = [
  CompanySearchComponent,
  UserPasswordFormComponent,
  ConfirmationPopupComponent,
  TablePaginationComponent,
  DatePickerComponent,
  EquipmentStatusComponent,
  CopyFeedbackPopupComponent,
  DidStatusComponent,
  NumberTypeComponent,
  NumberTemporaryStatusComponent,
  ConfirmationAlphanamePopupComponent,
  ConfirmationAlphanamePopupComponent,
  QuantitySelectorComponent,
  VerficationDataFormComponent,
  VerificationDataLabelComponent,
  VerificationDataSelectionFormComponent,
  SubscriptionChangeCheckboxesComponent,
  PaymentInfoComponent,
  LineItemComponent,
  FooterCardComponent,
  DiscountItemComponent,
  CouponFormComponent,
  ConnectionTypeComponent,
  ResellerPaymentStatusComponent,
  ConnectivityEntryTypeComponent,
  SelectProviderComponent,
  IntegrationStatusComponent,
  StatusIconComponent,
  IntegrationSelectUserComponent,
  IntegrationSelectTeamComponent,
  IntegrationsTableComponent,
  IntegrationUserMappingComponent,
  SmsBundleBalanceComponent,
  SmsFraudLimitsComponent,
  FraudRateLimitsPopupComponent,
  LinksPopupComponent
];
const PIPES = [
  DidTypePipe,
  DidClassPipe,
  DidStatusPipe,
  PrettyPrintPipe,
  CountryCurrencyPipe,
  NoUnderscorePipe
];


@NgModule({
    declarations: [
        ...COMPONENTS,
        ...PIPES,
        IntegrationStatusComponent,
        StatusIconComponent,
        IntegrationSelectUserComponent
    ],
    imports: [
        NgbModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        NgxSkeletonLoaderModule,
        NgVoxloudModule.forRoot({
            apiUrl: environment.apiEndpoint,
            production: environment.production
        }),
        LaddaModule.forRoot({
            spinnerColor: 'grey',
            style: 'zoom-in'
        }),
        RouterModule
    ],
    providers: [
        AddressService,
        VerifyPhoneNumberService,
        UtilsService,
        NgbActiveModal
    ],
    exports: [
        ...COMPONENTS,
        ...PIPES,
        NgVoxloudModule
    ]
})
export class SharedModule { }
